import styled from 'styled-components';

const List = styled.ol`
  list-style-type: none;
  margin-left: 0;
`;

export default List;
